import React, { useState, useEffect } from "react";
import classNames from "classnames";

const Lock = ({ value = false, onChange }) => {
  const toggleLocked = () => {
    onChange(!value);
  };

  const divClasses = classNames("btn", "eb-padding__lock-button", {
    "btn-primary": value,
    "btn-default": !value
  });

  return (
    <div className="eb-padding__lock">
      <div className={divClasses} onClick={toggleLocked}>
        <i className="eb-padding__lock-icon fi fi-lock" />
      </div>
    </div>
  );
};

export default Lock;
